import React, { useEffect, useState } from 'react';
import ChatSessionsTable from '../../../components/Tables/ChatSessionsTable';
import { useAgents } from '../../../contexts/AgentsContext';
import { getChatSessions } from "../../../services/agents";
import ChatSession from "../../../components/Chat/ChatSession";
import StartAgentChatDialog from '../../../components/Dialogs/StartAgentChatDialog';

export const ChatSessions = ({ style = {} }) => {
  const { selectedAgent, selectedChatSession, setSelectedChatSession } = useAgents();
  const [chatSessions, setChatSessions] = useState([]);
  const [showStartAgentChatDialog, setShowStartAgentChatDialog] = useState(false);

  useEffect(() => {
    const fetchChatSessions = async () => {
      if (selectedAgent) {
        // Fetch chat sessions for the selected agent
        const chatSessions = await getChatSessions(selectedAgent.public_id);
        setChatSessions(chatSessions);
      }
    };
    fetchChatSessions();


  }, [selectedAgent]);

  return (
    <div style={style}>
      <ChatSessionsTable
        chatSessions={chatSessions}
        onNewChat={() => {
          /*const chatSession = await startChatSession(selectedAgent.public_id);
          console.log("!!! NEW CHAT SESSION: ", chatSession);
          setChatSessions((prev) => [chatSession, ...prev]);
          setSelectedChatSession(chatSession);*/
          setShowStartAgentChatDialog(true);
        }}
        onSelect={(chatSession) => {
          setSelectedChatSession(chatSession);
        }}
        style={{ display: selectedChatSession ? "none" : "block" }}
      />
      <ChatSession chat_session_id={selectedChatSession?.public_id} agent={selectedAgent}
        style={{ flex: 1, display: selectedChatSession ? "block" : "none" }}
      />
      <StartAgentChatDialog
        title={`Start new chat with ${selectedAgent?.name ?? "agent"}`}
        show={showStartAgentChatDialog}
        agent={selectedAgent}
        onClose={() => {
          console.log("!!! CLOSING START AGENT CHAT DIALOG");
          setShowStartAgentChatDialog(false);
        }}
        onChatStarted={(chatSession) => {
          console.log("!!! HERE ARE THE CHAT SESSION DETAILS: ", chatSession);
          setSelectedChatSession(chatSession);
          setChatSessions((prev) => [chatSession, ...prev]);
          setShowStartAgentChatDialog(false);
        }}
      />

    </div>
  );
};

export default ChatSessions;
